import React from "react";
import { useDrop } from "react-dnd";
import Coin from "../components/Coin";
import coin_1 from "../images/coin_1.png";
import coin_16 from "../images/coin_16.png";
import coin_2 from "../images/coin_2.png";
import coin_32 from "../images/coin_32.png";
import coin_4 from "../images/coin_4.png";
import coin_8 from "../images/coin_8.png";
import "./Box.css";


const coinImages = [coin_32, coin_16, coin_8, coin_4, coin_2, coin_1];

/* 
This component implements a box into which coins can be dropped.
Parts of it were created with the help of LLMs.
*/
function BinaryBoxOrigin({ id, droppedCoins, onDropCoin, coinSize }) {
  const [, drop] = useDrop({
    accept: "coin",
    drop: (item, monitor) => {
      if (!monitor.didDrop()) {
        onDropCoin(item.id, id); // item.id is 2d-array. item[0] is index of coin that was dropped, that index corresponds to a char (e.g. in Roman 2 = 'X'). id is the index of the box it was dropped in.
      }
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
      canDrop: !!monitor.canDrop(),
    }),
  });

  const coinStyle = {
    width: coinSize+"dvh",
    height: coinSize+"dvh",
    display: "flex",
    justifyContent: "center",
    zIndex: 1,
    marginLeft: "2dvh",
    marginRight: "2dvh",
    marginBottom: "1dvh",
  };

  const boxStyle = {
    display: "flex",
    flexDirection: "row",
    width: "150dvh",
    height: "20dvh",
    zIndex: 0,
    borderRadius: "0.25em",
    justifyContent: "center",
  };

  const dropStyle = {
    maxWidth: "150dvh",
    maxHeight: "20dvh",
    backgroundColor: "none",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    alignContent: "center",
  };

  return (
    <div ref={drop} style={dropStyle}>
      <div alt="BinaryBox" style={boxStyle}>
        <React.Fragment key={id}>
          {(Array.from({ length: 6 }).map((_, coinId) => (
            <div style={{display: "flex", flexDirection: "column"}}>
                {droppedCoins[coinId] === 0 && <span style={coinStyle}><Coin key={[coinId, 0]} id={[coinId, 0]} coinImage={coinImages[coinId]}/></span>}
                {droppedCoins[coinId] === 1 && <span key={coinId} style={{...coinStyle, opacity: "0.3"}}><img style={{width: "100%", height: "100%"}} src={coinImages[coinId]} alt="coin"/></span>}
            </div>
            ))
          )}
        </React.Fragment>
      </div>
    </div>
  );
}

export default BinaryBoxOrigin;
